import React from "react";
import { ApplicationStepStatus } from "@/enum/ApplicationStepStatus";
import { Check, Lock, Circle } from "lucide-react";
import { cn } from "@/lib/utils";

export enum StepIconSize {
  Small,
  Normal,
}

interface StepIconProps {
  stepStatus?: ApplicationStepStatus;
  size?: StepIconSize;
}

const StepIcon = ({ stepStatus = ApplicationStepStatus.Disabled, size = StepIconSize.Normal }: StepIconProps) => {
  const isSmall = size === StepIconSize.Small;
  const iconSize = isSmall ? "size-3" : "size-3.5";

  if (stepStatus === ApplicationStepStatus.Complete) {
    return (
      <span
        className={cn(
          "relative z-10 flex items-center justify-center rounded-full bg-emerald-500 text-white shrink-0",
          isSmall ? "size-6" : "size-8",
        )}
      >
        <Check className={iconSize} strokeWidth={3} />
      </span>
    );
  }

  if (stepStatus === ApplicationStepStatus.Active || stepStatus === ApplicationStepStatus.InProgress) {
    return (
      <span
        className={cn(
          "relative z-10 flex items-center justify-center rounded-full border-2 border-emerald-500 bg-emerald-50 shrink-0",
          isSmall ? "size-6" : "size-8",
        )}
      >
        <Circle className={cn(iconSize, "fill-emerald-500 text-emerald-500")} />
      </span>
    );
  }

  if (stepStatus === ApplicationStepStatus.Enabled) {
    return (
      <span
        className={cn(
          "relative z-10 flex items-center justify-center rounded-full border-2 border-gray-300 bg-white shrink-0",
          isSmall ? "size-6" : "size-8",
        )}
      >
        <Circle className={cn(iconSize, "text-gray-300")} />
      </span>
    );
  }

  // Disabled
  return (
    <span
      className={cn(
        "relative z-10 flex items-center justify-center rounded-full bg-gray-100 text-gray-400 shrink-0",
        isSmall ? "size-6" : "size-8",
      )}
    >
      <Lock className={iconSize} />
    </span>
  );
};

export default StepIcon;
